import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DialogContent, Button, Zoom } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'visible'
        }
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(6),
        maxWidth: '600px',
        animation: undefined,
        background: 'linear-gradient(45deg, #2d323d 0%, #1b1e24 100%)',
        borderRadius: '24px',
        margin: 0,
        backgroundColor: 'transparent',
        '&.MuiDialogContent-root': {
            padding: theme.spacing(6),
        }
    },
    logo: {
        width: '200px',
        marginBottom: theme.spacing(6),
        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))'
    },
    title: {
        fontSize: '28px',
        fontWeight: 500,
        textAlign: 'center',
        lineHeight: 1.4,
        marginBottom: theme.spacing(5),
        color: 'white'
    },
    gradient: {
        background: 'linear-gradient(45deg, #4285f4, #2196f3)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 600
    },
    buttonContainer: {
        display: 'flex',
        gap: theme.spacing(2)
    },
    button: {
        padding: '16px 40px',
        fontSize: '16px',
        fontWeight: 500,
        borderRadius: '16px',
        transition: 'all 0.2s ease',
    },
    learnButton: {
        color: 'white',
        background: 'linear-gradient(45deg, #1976d2, #2196f3)',
        boxShadow: '0 2px 8px rgba(33, 150, 243, 0.15)',
        '&:hover': {
            background: 'linear-gradient(45deg, #1565c0, #1976d2)',
            boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)',
        }
    },
    closeButton: {
        color: '#2196f3',
        background: 'rgba(33, 150, 243, 0.12)',
        boxShadow: '0 2px 8px rgba(33, 150, 243, 0.08)',
        '&:hover': {
            background: 'rgba(33, 150, 243, 0.18)',
            boxShadow: '0 4px 12px rgba(33, 150, 243, 0.1)',
        }
    }
}));

const TrainingLogoutDialog = ({ onClose }) => {
    const classes = useStyles();

    return (
        <Zoom in timeout={400}>
            <DialogContent className={classes.root}>
                <img
                    src="assets/images/logos/heidi_white_simple_logo.png"
                    alt="adaptive"
                    className={classes.logo}
                />

                <div className={classes.title}>
                    Thank you for using<br />
                    <span className={classes.gradient}>
                        Adaptive Computing's<br />
                        Heidi AI
                    </span>
                </div>

                <div className={classes.buttonContainer}>
                    <Button
                        className={`${classes.button} ${classes.learnButton}`}
                        onClick={() => window.open('https://adaptivecomputing.com/contact-form-request-for-info/', '_blank')}
                    >
                        Contact Us
                    </Button>
                    <Button
                        className={`${classes.button} ${classes.closeButton}`}
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </div>
            </DialogContent>
        </Zoom>
    );
};

export default TrainingLogoutDialog;